
import { Component, Vue, Prop } from "vue-property-decorator"

import { ReportInsight } from "@/types/report"

import TableResults from "@/components/Insights/TableResults.vue"
import ChartResults from "@/components/Insights/ChartResults.vue"

import { DisplayCell } from "@/types/dashboard"
import { CaseColumn } from "@/types/caseColumns"
import { LabelFormat } from "@/types/insights"
import CalculationTable from "../Insights/CalculationTable.vue"
import { CalculatedResults } from "@/types/insights/calculatedResults"

@Component({
	components: {
		"table-results": TableResults,
		"chart-results": ChartResults,
		"calculation-table": CalculationTable
	}
})
export default class ReportCell extends Vue {
	// --- Props ---

	@Prop({ required: true })
	cell!: DisplayCell

	@Prop({ required: true })
	data!: { [key: string]: ReportInsight }

	@Prop({ required: true })
	columns!: { [key: string]: CaseColumn }

	// --- Computed Properties ---

	get insightId () {
		return this.cell.contents.insightId
	}

	get insight () {
		return this.data[this.insightId].insight
	}

	get tableColumns () {
		const insight = this.data[this.insightId]
		if (!insight) return []
		return insight.insight.columns.map(tableColumn => this.columns[tableColumn])
			.filter(c => !!c)
	}

	get calculatedResults (): CalculatedResults {
		return this.data[this.insightId].results
	}

	get results () {
		return this.calculatedResults.results
	}

	get resultsWithValues () {
		return this.results.filter(r => r.results.length > 0)
	}

	get graphCalculations (): string[] {
		return this.cell.contents.graphCalculations || []
	}

	get labelFormat (): LabelFormat {
		return this.calculatedResults.labelFormat
	}

	get chartLabels (): number {
		if (this.cell.contents.chartType === "PieChart") {
			return this.data[this.insightId].results.results.length
		}

		return this.graphCalculations.reduce((t, c) => {
			const calculation = this.insight.calculations.find(calc => calc.key === c)
			if (calculation) {
				t += calculation.groupBy
					? calculation.groupByKeyLabels ? Object.keys(calculation.groupByKeyLabels).length : 1
					: 1
			}
			return t
		}, 0)
	}

	get chartHeightStyle (): { height: string } {
		const pixelHeight = this.cell.h * 450
		return { height: `${pixelHeight}px` }
	}

	get chartHeight () {
		const heightPercent = this.cell.contents.chartType === "PieChart"
			? Math.max(85 - (this.chartLabels * 1.1), 40)
			: Math.max(85 - (this.chartLabels / 1.1), 50)
		return heightPercent.toString() + "%"
	}
}
